import { render, staticRenderFns } from "./uploadRetRemessa.vue?vue&type=template&id=25bb7662&"
import script from "./uploadRetRemessa.vue?vue&type=script&lang=js&"
export * from "./uploadRetRemessa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports